import { PlanShared } from './../../../presentation/general/shared/plan-shared';
import { DietApiService } from './diet-api.service';
import { FoodDataService } from './food-data.service';
import {
  DietDayFoodLogsModel,
  FoodLogModel,
} from './../../../core/model/object/foodlog-model';
import { FoodLogDataService } from './food-log-data.service';
import {
  AddFoodLogInputModel,
  AddQuikFoodLog,
} from './../../../core/model/input/food-log-input-model';
import {
  GetFoodLogResponseModel,
  AddFoodLogResponseModel,
  UpdateFoodLogResponseModel,
  RemoveFoodLogResponseModel,
  GetFoodLogChartResponseModel,
} from './../../../core/model/api-response/food-log-response-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from 'src/app/global-variables';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { WebengageService } from '../analytics-repository/webengage.service';

@Injectable({
  providedIn: 'root',
})
export class FoodLogService {
  foodIds = [];

  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService,
    private foodLogDataService: FoodLogDataService,
    private foodDataService: FoodDataService,
    private dietApiService: DietApiService,
    private planShared: PlanShared,
    private webengage: WebengageService
  ) {}

  async getFoodLog(
    startDate: number,
    updatedAt: number
  ): Promise<GenericResponse> {
    let update = false;
    if (updatedAt !== 0) {
      update = true;
    }
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetFoodLogResponseModel>(
        baseUrl +
          'api/v2/foodlog?date=' +
          startDate +
          '&updatedAt=' +
          updatedAt,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        let updated = false;
        if (update && res.foodLog.length !== 0) {
          await this.foodLogDataService.updateFoodLogs(res.foodLog, startDate);
          updated = true;
        } else if (update && res.foodLog.length === 0) {
          await this.foodLogDataService.saveFoodLogs(null, startDate);
          updated = false;
        } else {
          await this.foodLogDataService.saveFoodLogs(res.foodLog, startDate);
          updated = true;
        }
        if (res.deletedLogs && res.deletedLogs.length !== 0) {
          const deleteUpdated = await this.foodLogDataService.removeFoodLogs(
            startDate,
            res.deletedLogs
          );
          updated = updated || deleteUpdated;
        }
        await this.prepareFoodIds(res.foodLog);
        if (this.foodIds.length !== 0) {
          const r = await this.dietApiService.getFoods(this.foodIds, true);
        }
        response = new GenericResponse(
          res.success,
          new GenericResponseData({ type: updated ? 'updated' : 'same' })
        );
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFoodLog(startDate, updatedAt);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }
  async addQuikFood(addFoodLogs: AddQuikFoodLog[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<AddFoodLogResponseModel>(baseUrl + 'api/v2/foodlog', addFoodLogs, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        this.webengage.addFoodLog(addFoodLogs[0].meal, 'quick');
        const date = res.foodLog[0].date;
        const response = await this.foodLogDataService.updateFoodLogs(
          res.foodLog,
          date
        );
        let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(
          date
        );
        dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
        this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            message: res.message,
            foodLogs: res.foodLog,
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.addQuikFood(addFoodLogs);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  public async prepareDietDayFoodLogs(
    dietDayFoodLogs: DietDayFoodLogsModel
  ): Promise<DietDayFoodLogsModel> {
    for (let foodLog of dietDayFoodLogs.foodLogs) {
      // console.log(foodLog);

      if (!foodLog.calorie && !foodLog.calorie) {
        let food = await this.foodDataService.getFood(foodLog.food);
        if (food) {
          foodLog.foodModel = food;
        } else {
          await this.dietApiService.getFoods([foodLog.food], true);
          food = await this.foodDataService.getFood(foodLog.food);
          foodLog.foodModel = food;
        }
      }
    }
    return Promise.resolve(dietDayFoodLogs);
  }
  addFoodLog(addFoodLogs: AddFoodLogInputModel[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<AddFoodLogResponseModel>(
        baseUrl + 'api/v2/foodlog',
        [...addFoodLogs],
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            message: res.message,
            foodLogs: res.foodLog,
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.addFoodLog(addFoodLogs);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  updateFoodLog(
    id: string,
    amount: number,
    unit: string,
    calorie?: number
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<UpdateFoodLogResponseModel>(
        baseUrl + 'api/v2/foodlog/' + id,
        {
          amount,
          unit,
          calorie,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ message: res.message })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.updateFoodLog(id, amount, unit);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  deleteFoodLog(ids: string[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: {
        ids,
      },
    };
    return this.http
      .delete<RemoveFoodLogResponseModel>(baseUrl + 'api/v2/foodlog', options)
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ message: res.message })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deleteFoodLog(ids);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async getFoodLogChart(
    from: number,
    to: number,
    segment: string
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetFoodLogChartResponseModel>(
        baseUrl +
          'api/v2/foodlog/chart?from=' +
          from +
          '&to=' +
          to +
          '&segment=' +
          segment,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ foodLogChart: res.chart })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFoodLogChart(from, to, segment);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async prepareFoodIds(foodLogs: FoodLogModel[]): Promise<boolean> {
    this.foodIds = [];
    foodLogs.forEach((foodLog) => {
      this.foodIds.push(foodLog.food);
    });

    const uniqueSet = new Set(this.foodIds);
    this.foodIds = [...uniqueSet];
    this.foodIds = await this.foodDataService.checkFoodIds(this.foodIds);
    return Promise.resolve(true);
  }
}
